<template>
  <div class="xb-order-return-detail">
    <Breadcrumb :breadcrumbData="breadcrumbData"></Breadcrumb>
    <div class="return-detail-main">
      <div class="message">
        <div class="left">
          <p>
            <span>退单时间：</span>
            <span>{{ list.time }}</span>
          </p>
          <p>
            <span>退单号：</span>
            <span>{{ list.refundCode }}</span>
          </p>
          <p>
            <span>当前退单状态：</span>
            <span>{{ list.status }}</span>
          </p>
        </div>
        <div class="right">
          <el-button @click="toOrderDetail(list.orderCode)">关联订单</el-button>
        </div>
      </div>
      <div class="table-img">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="名称">
            <template slot-scope="scope">
              <img class="img" :src="scope.row.img" alt />
              <p class="name" :title="scope.row.name">{{scope.row.name}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="specifications" label="规格" width="200"></el-table-column>
          <el-table-column prop="price" label="单价" width="208"></el-table-column>
          <el-table-column prop="number" label="数量" width="208"></el-table-column>
          <el-table-column prop="sum" label="小计" width="208"></el-table-column>
        </el-table>
        <div class="table-footer">
          <div class="total">
            <span>订单合计：</span>
            <span class="price">￥{{totalPrice}}</span>
          </div>
          <div class="actual-amount">
            <span>实际退货金额：</span>
            <span class="price">￥{{realRefundMoney}}</span>
          </div>
        </div>
      </div>
      <div class="refund-information">
        <div class="tit">退款信息：</div>
        <div class="information">
          <ul class="ul-list" v-if="orderPaymentMethod===4">
            <li class="list">退款将退回至原银行账户</li>
          </ul>
          <ul class="ul-list" v-else>
            <li class="list">
              账户名称：
              <span>{{form.accountHolder}}</span>
            </li>
            <li class="list">
              开户银行：
              <span>{{form.bank}}</span>
            </li>
            <li class="list">
              银行账号：
              <span>{{form.bankAccount}}</span>
            </li>
          </ul>
          <ul class="ul-list">
            <li class="list">
              退货地址：
              <span>{{form.address}}</span>
            </li>
            <li class="list">
              物流信息：
              <span>{{form.logisticsCompany}} {{form.logisticsNumber}}</span>
              <el-button type="text" @click="dialogVisible = true">查看物流</el-button>
              <el-dialog title="物流信息" :visible.sync="dialogVisible" width="400px" top="25vh">
                <p class="border"></p>
                <div class="container" v-if="form.logisticsNumber">
                  <div class="express">
                    <p class="express-p">{{form.logisticsCompany}}</p>
                    <p class="express-p">单号：{{form.logisticsNumber}}</p>
                  </div>
                  <ul class="list">
                    <li v-for="(value,index) in express" :key="index">
                      <i></i>
                      <p class="space">{{value.remark}}</p>
                      <p class="time">{{value.datetime}}</p>
                    </li>
                  </ul>
                </div>
                <div v-else class="noExpress">暂无物流信息</div>
              </el-dialog>
            </li>
            <li class="list">
              退货留言：
              <span>{{form.bemarks}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from 'base/xb-base/Breadcrumb';
import XBOrderReturn from 'models/xb/orderReturn.js';
const xbOrderReturn = new XBOrderReturn();
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      breadcrumbData: [
        {
          name: '退货单',
          url: '/personal/personal-menu/xb-order-return'
        },
        {
          name: '退货详情',
          url: ''
        }
      ],
      list: {
        refundCode: '',
        time: '',
        status: '',
        orderCode: ''
      },
      tableData: [
        // {
        //   img: 'https://i1.mifile.cn/a1/pms_1550642182.7527088!220x220.jpg',
        //   name: '哈哈哈哈哈哈哈哈哈哈或或或或哈哈哈哈哈哈哈哈哈哈',
        //   price: '￥12.00',
        //   number: 100,
        //   sum: 1200
        // }
      ],
      form: {
        accountHolder: '',
        bank: '',
        bankAccount: '',
        bemarks: '',
        address: '',
        logisticsCompany: '',
        logisticsNumber: ''
      },
      orderPaymentMethod: '', // 订单支付方式
      express: [], // 物流列表
      totalPrice: 0, // 退货金额
      realRefundMoney: 0, // 实际退货金额
      dialogVisible: false
    };
  },
  beforeMount() {
    let refundCode = this.$route.query.refundCode;
    this.list.refundCode = refundCode;
    this.getDetail(refundCode);
    this.getExpressDetail(refundCode);
  },
  methods: {
    // 获取退货详情数据进行退货单填写
    getDetail(refundCode) {
      xbOrderReturn.getXBOrderReturnDetail(refundCode).then(res => {
        // console.log(res);
        if (res.success) {
          this.list.time = this.fmtDate(res.result.refundOrder.createTime);
          this.list.statusNum = res.result.refundOrder.status;
          this.list.status = this.getCodeName(res.result.refundOrder.status);
          this.list.orderCode = res.result.refundOrder.orderCode;
          let arr = [];
          res.result.refundDetailList.map((value, index, array) => {
            let obj = {};
            obj.id = value.goodsId;
            obj.img = value.goodsPic
              ? value.goodsPic
              : 'http://image.8844it.com/ydb2/goodDefault.png';
            obj.name = value.goodsName;
            obj.price = value.goodsUnitPrice;
            obj.number = value.quantity;
            obj.sum = value.subtotal;
            let itemTitle = JSON.parse(value.itemTitle);
            let specifications = '';
            for (let key in itemTitle) {
              specifications += `,${itemTitle[key]}`;
            }
            obj.specifications = specifications.substring(1);
            arr.push(obj);
          });
          this.tableData = arr;
          this.address = res.result.refundAddress.totalAddress;
          this.totalPrice = res.result.refundOrder.totalPrice;
          this.realRefundMoney = res.result.refundOrder.realRefundMoney;
          this.orderPaymentMethod = res.result.refundOrder.orderPaymentMethod;
          this.form.accountHolder = res.result.refundOrder.bankUser
            ? res.result.refundOrder.bankUser
            : '暂无';
          this.form.bank = res.result.refundOrder.bankName
            ? res.result.refundOrder.bankName
            : '暂无';
          this.form.bankAccount = res.result.refundOrder.bankAccount
            ? res.result.refundOrder.bankAccount
            : '暂无';
          this.form.bemarks = res.result.refundOrder.refundMessage
            ? res.result.refundOrder.refundMessage
            : '';
          this.form.address = res.result.refundAddress.totalAddress
            ? res.result.refundAddress.totalAddress
            : '暂无';
          this.form.logisticsCompany = res.result.refundExpress.expressName
            ? res.result.refundExpress.expressName
            : '暂无';
          this.form.logisticsNumber = res.result.refundExpress.expressCode;
        }
      });
    },
    // 根据订单状态返回对应的值
    getCodeName(status) {
      let statusName = [
        '待退货审核',
        '待退货',
        '退货确认',
        '待退款',
        '待收款',
        '已完成',
        '已取消',
        '已拒绝'
      ];
      return statusName[status];
    },
    // 获取退单物流信息
    getExpressDetail(refundCode) {
      xbOrderReturn.getXBOrderReturnExpress(refundCode).then(res => {
        if (res.success) {
          if (res.result) {
            res.result.Traces.map(item => {
              let datetime = item.AcceptTime;
              let remark = item.AcceptStation;
              this.express.unshift({
                datetime,
                remark
              });
            });
          }
        }
      });
    },
    // 关联订单
    toOrderDetail(orderCode) {
      this.$router.push({
        path: '/personal/xb-order-detail',
        query: {
          orderCode
        }
      });
    },
    // 时间格式转换
    fmtDate(date) {
      let dateFn = new Date(date);
      let yy = dateFn.getFullYear();
      let mm = dateFn.getMonth() + 1;
      let dd = dateFn.getDate();
      let hh =
        dateFn.getHours() < 10
          ? '0' + dateFn.getHours()
          : '' + dateFn.getHours();
      let xx =
        dateFn.getMinutes() < 10
          ? '0' + dateFn.getMinutes()
          : '' + dateFn.getMinutes();
      let ss =
        dateFn.getSeconds() < 10
          ? '0' + dateFn.getSeconds()
          : '' + dateFn.getSeconds();
      let time = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + xx + ':' + ss;
      return time;
    }
  }
};
</script>
<style lang='scss' scoped>
.xb-order-return-detail {
  color: #606266;
  .return-detail-main {
    padding: 20px;
    background: #fff;
    min-height: 600px;
    .message {
      display: flex;
      height: 32px;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      margin-bottom: 20px;
      .left {
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
          margin-right: 100px;
        }
      }
      .right {
        .el-button {
          width: 120px;
          height: 32px;
          border-radius: 4px;
          border: 1px solid rgba(223, 52, 69, 1);
          background: #fff;
          font-size: 16px;
          color: rgba(223, 52, 69, 1);
        }
      }
    }
    .table-img {
      margin-bottom: 24px;
      .table-footer {
        height: 32px;
        box-sizing: border-box;
        border: 1px solid #f2f6fc;
        border-top: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 14px;
        .total {
          width: 208px;
          .price {
            font-size: 16px;
          }
        }
        .actual-amount {
          width: 248px;
          .price {
            font-size: 16px;
            color: #df3445;
          }
        }
      }
    }
    .refund-information {
      font-size: 14px;
      margin-bottom: 150px;
      padding-left: 20px;
      .tit {
        line-height: 22px;
        margin-bottom: 12px;
      }
      .information {
        display: flex;
        .ul-list {
          flex: 1;
          .list {
            line-height: 32px;
            .el-button {
              width: 52px;
              height: 32px;
              font-size: 12px;
              font-family: "PingFangSC-Regular";
              font-weight: 400;
              color: rgba(61, 116, 242, 1);
              line-height: 30px;
              letter-spacing: 1px;
              padding: 0;
              margin-left: 16px;
              span {
                display: inline-block;
                height: 30px;
                line-height: 30px;
                color: red;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.xb-order-return-detail {
  .refund-information {
    .list {
      .el-input {
        width: 320px;
      }
      .el-dialog {
        height: 400px;
        font-family: "PingFangSC-Regular";
        .el-dialog__header {
          padding: 12px 24px;
          line-height: 24px;
          font-size: 16px;
          color: #606266;
          .el-dialog__headerbtn {
            top: 13px;
          }
        }
        .el-dialog__body {
          padding: 0;
          .border {
            border-top: 1px solid #f7f7f7;
            margin: 0 24px;
          }
          .container {
            height: 319px;
            overflow: auto;
            padding: 0 24px;
            .express {
              padding: 8px 0px;
              display: flex;
              .express-p {
                line-height: 24px;
                height: 24px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(96, 98, 102, 1);
                line-height: 24px;
                letter-spacing: 1px;
                margin-right: 24px;
              }
            }
            .list {
              padding-left: 14px;
              padding-bottom: 20px;
              li {
                border-left: 1px solid #f7f7f7;
                padding-left: 23px;
                position: relative;
                color: #919398;
                i {
                  position: absolute;
                  display: inline-block;
                  left: -5px;
                  width: 9px;
                  height: 9px;
                  border-radius: 50%;
                  background: #c0c4cc;
                }
                .space {
                  font-size: 12px;
                  line-height: 17px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                }
                .time {
                  font-size: 12px;
                  line-height: 17px;
                  padding-bottom: 5px;
                  border-bottom: 1px solid #f7f7f7;
                }
              }
            }
            .list li:nth-child(1) {
              i {
                position: absolute;
                display: inline-block;
                left: -8px;
                width: 15px;
                height: 15px;
                border-radius: 50%;
                background: #3d74f2;
              }
            }
          }
          .noExpress {
            text-align: center;
            padding-top: 100px;
          }
        }
      }
    }
  }
}
</style>
